export default "__VITE_ASSET__DF6_Cv2s__"